import { view } from '@yola/ws-sdk';
import compileCustomTemplate from './compile-custom-template';
import extractScriptsFromTemplate from './extract-scripts-from-template';
import constants from '../constants';

const { SCRIPT_REGEXP } = constants;

const prepareNodeElement = ({
  elementVariable,
  customTemplate,
  config,
  elementDataAttribute,
  elementDataParentAttribute,
} = {}) => {
  const liveDocument = view.accessors.getLiveDocument();
  const variable = elementVariable.find((item) => item.querySelector);
  const element = liveDocument.querySelector(variable.querySelector);

  if (!element)
    return {
      compiledElement: null,
      element: null,
    };

  const compiledElement = element.cloneNode(false);
  const compiledCustomTemplate = compileCustomTemplate(customTemplate, config);

  if (compiledCustomTemplate.match(SCRIPT_REGEXP)) {
    const { scripts, template } = extractScriptsFromTemplate(compiledCustomTemplate);

    compiledElement.innerHTML = template;

    scripts.forEach((scriptElement) => {
      compiledElement.appendChild(scriptElement);
    });
  } else {
    compiledElement.innerHTML = compiledCustomTemplate;
  }

  compiledElement.setAttribute(elementDataAttribute, config.id);

  if (config.parentId) {
    compiledElement.setAttribute(elementDataParentAttribute, config.parentId);
  } else if (compiledElement.hasAttribute(elementDataParentAttribute)) {
    compiledElement.removeAttribute(elementDataParentAttribute);
  }

  return {
    compiledElement,
    element,
  };
};

export default prepareNodeElement;
